import { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  TextField,
  Button,
  IconButton,
  Paper,
} from "@mui/material";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import emailjs from "@emailjs/browser";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [successMessage, setSuccessMessage] = useState("");
  const [viewMessage, setViewMessage] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          from_name: formData.name,
          to_name: "Kemi",
          email: formData.email,
          message: formData.message,
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

      setSuccessMessage("Message sent successfully!");
      setFormData({ name: "", email: "", message: "" });
      setViewMessage(true);
    } catch (error) {
      console.error("Error sending message:", error);
      setSuccessMessage("Failed to send message. Please try again.");
      setViewMessage(true);
    }
    finally {
      setTimeout(() => {
        setViewMessage(false);
      }, 4000);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Box
      sx={{
        py: 12,
        backgroundColor: "background.paper",
        position: "relative",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "100%",
          // background: "linear-gradient(45deg, #FFC107 0%, #1A1A1A 100%)",
          opacity: 0.1,
        },
      }}
    >
      <Container maxWidth="lg">
        {viewMessage && (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Typography
              variant="body1"
              color="#000"
              sx={{
                textAlign: "center",
                width: "20%",
                mb: 4,
                borderRadius: 2,
                backgroundColor: "#fff",
                padding: ".5rem 1rem",
              }}
            >
              {successMessage}
            </Typography>
          </Box>
        )}
        <Typography
          variant="h2"
          sx={{
            textAlign: "center",
            mb: 8,
            color: "primary.main",
            position: "relative",
            "&::after": {
              content: '""',
              position: "absolute",
              bottom: "-16px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "60px",
              height: "4px",
              backgroundColor: "primary.main",
            },
          }}
        >
          Get In Touch
        </Typography>

        <Grid container spacing={6}>
          <Grid item xs={12} md={6}>
            <Paper
              elevation={0}
              sx={{
                p: 4,
                height: "100%",
                backgroundColor: "background.default",
              }}
            >
              <Typography variant="h4" gutterBottom>
                Let's Connect
              </Typography>
              <Typography
                variant="body1"
                sx={{ mb: 4, color: "text.secondary" }}
              >
                Feel free to reach out for collaborations, opportunities, or
                just a friendly chat.
              </Typography>

              <Box sx={{ display: "flex", gap: 2 }}>
                <IconButton
                  href="mailto:oluwakemiakindele7@gmail.com"
                  target="_blank"
                  sx={{ color: "primary.main" }}
                >
                  <EmailIcon />
                </IconButton>
                <IconButton
                  href="https://github.com/theyinda"
                  target="_blank"
                  sx={{ color: "primary.main" }}
                >
                  <GitHubIcon />
                </IconButton>
                <IconButton
                  href="https://www.linkedin.com/in/oluwakemi-akindele"
                  target="_blank"
                  sx={{ color: "primary.main" }}
                >
                  <LinkedInIcon />
                </IconButton>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper
              elevation={0}
              sx={{
                p: 4,
                backgroundColor: "background.default",
                // backgroundColor: "#000",
              }}
            >
              <form onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      variant="outlined"
                      sx={{
                        "&.Mui-focused": {
                          borderColor: "#fff",
                        },
                        "&:hover": {
                          borderColor: "primary.main",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "primary.main",
                          },
                         
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Email"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      variant="outlined"
                      sx={{
                        "&.Mui-focused": {
                          borderColor: "#fff",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "primary.main",
                          },
                         
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Message"
                      name="message"
                      multiline
                      rows={4}
                      value={formData.message}
                      onChange={handleChange}
                      required
                      variant="outlined"
                      sx={{
                        "&.Mui-focused": {
                          borderColor: "#fff",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "primary.main",
                          },
                         
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      variant="contained"
                      size="large"
                      fullWidth
                      sx={{
                        height: 56,
                        backgroundColor: "primary.main",
                        "&:hover": {
                          backgroundColor: "primary.dark",
                        },
                      }}
                    >
                      Send Message
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Contact;
